/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientData } from '../../models/client-data';

export interface GetAgentData$Params {
}

export function getAgentData(http: HttpClient, rootUrl: string, params?: GetAgentData$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientData>> {
  const rb = new RequestBuilder(rootUrl, getAgentData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientData>;
    })
  );
}

getAgentData.PATH = '/client/agentData';
